import React from 'react';

import classes from './FlightInfoBoxInnerRight.scss';

import FlightInfoCity from '../FlightInfoCity/FlightInfoCity';
import FlightInfoTerminal from '../FlightInfoTerminal/FlightInfoTerminal';

const flightInfoBoxInnerRight = (props) => {

    return (
        <div className={classes.Box}>
            <div className={`u-flex justify-content-between`}>
                <div className={classes.TakeOffBox}>
                <div className={classes.RowOne}>
                    <span className={classes.FlightTime}>{props.departureTime}</span>
                    <span className={classes.FlightCityHalf}>{props.origin}</span>
                </div>
                <div className="u-flex justify-content-between align-items-center mb-4">
                    <span className={classes.FlightDate}>
                        {props.dDate} {props.departureMonthUpdated},{" "}{props.departureDayUpdated}
                    </span>
                </div>
                <div className={classes.RowTwo}>
                    <FlightInfoCity>{props.originCity}</FlightInfoCity>
                </div>
                <div className={classes.RowThree}>
                    <FlightInfoTerminal align='left'>{props.originAirport} {props.departureTerminal ? <span className={`u-phoneHide mt-0 mb-0 ml-1 mr-1`}>|</span> : null} {props.departureTerminal ? props.departureTerminal : null}</FlightInfoTerminal>
                </div>
                </div>
                <div className={`u-flex f-column u-textAlignCenter`}>
                    <div className={classes.FlightDuration}>
                        <span className={`phone-ml-0`}>
                            {props.durationTime.includes(':') ? props.durationTime.substring(0, 2) + "h " + props.durationTime.substring(3, 5) + "m" : props.durationTime.substring(0, 2) + "h " + props.durationTime.substring(2, 4) + "m"}
                        </span>
                    </div>
                    <div className={classes.TechStopover}>{props.techStopover}</div>
                </div>
                <div className={classes.LandingBox}>
                <div className={classes.RowOne}>
                    <span className={classes.FlightCityHalf}>{props.destination}</span>
                    <span className={classes.FlightTime}>{props.arrivalTime}</span>
                </div>
                <div className="u-flex justify-content-end align-items-center mb-4">
                    <span className={classes.FlightDate}>
                        {props.aDate} {props.arrivalMonthUpdated}, {props.arrivalDayUpdated}
                    </span>
                </div>
                <div className={classes.RowTwo}>
                    <FlightInfoCity>{props.destinationCity}</FlightInfoCity>
                </div>
                <div className={classes.RowThree}>
                    <FlightInfoTerminal align='right'>{props.destinationAirport} {props.arrivalTerminal ? <span className={`u-phoneHide mt-0 mb-0 ml-1 mr-1`}>|</span>  : null} {props.arrivalTerminal ? props.arrivalTerminal : null}</FlightInfoTerminal>
                </div>
                </div>
            </div>
            <div className={`mt-2 mb-2 u-borderBottomNormal`}></div>
            <div className={`u-flex justify-content-between align-items-center`}>
                {props.baggage ? <span className={`u-fontSize13 u-textColorNormal u-textCapitalize`}>Check-in Baggage&nbsp;{props.baggage}</span> : null}
                {props.meal ? <span className={`u-fontSize13 u-textColorNormal u-textCapitalize`}>{props.meal}</span> : null}
            </div>
        </div>
    );
}

export default flightInfoBoxInnerRight;


// WEBPACK FOOTER //
// ./src/components/Flight/Tuple/TupleInner/FlightInfo/FlightInfoBoxInnerRight/FlightInfoBoxInnerRight.js